import { Col, Drawer, Row } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import ActionButtons from "../Components/ActionButtons";
import Button from "../Components/Button";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import Budget from "./Budget";
import Levels from "./Levels";
import Needs from "./Needs";

function View({ fields, onNext, onBack, categories }) {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [budget, setBudget] = useState(
    get(fields, "budget.max")
      ? { min: get(fields, "budget.min"), max: get(fields, "budget.max") }
      : {},
  );
  const [selectedValues, setSelectedValues] = useState(
    categories.reduce((acc, category) => {
      acc[category.value] = get(fields, `needs.${category.value}`, 1);
      return acc;
    }, {}),
  );
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Layout>
      <Header
        title="Quel <b>niveau de protection</b> recherchez-vous ?"
        highlight="recherchez-vous"
        subtitle="Personnalisation de votre couverture"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={16} lg={12}>
          <Needs
            categories={categories}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onClick={() => setDrawerVisible(true)}
          />
          <Budget
            value={budget?.max ? `${budget.min}-${budget.max}` : null}
            options={[
              { value: "0-50", label: "Entre 0 et 50 €" },
              { value: "50-100", label: "Entre 50 et 100 €" },
              { value: "100-200", label: "Entre 100 et 200 €" },
              { value: "200-500", label: "Entre 200 et 500 €" },
              { value: "500-1000", label: "Entre 500 et 1000 €" },
              { value: "1000-9999", label: "Plus de 1000 €" },
            ]}
            onChange={(e) => {
              const [min, max] = e.split("-");
              setBudget({ min: parseInt(min), max: parseInt(max) });
            }}
          />
        </Col>
      </Row>

      <ActionButtons
        onNext={() =>
          onNext({
            payload: {
              fields: {
                ...fields,
                budget,
                needs: selectedValues,
              },
            },
          })
        }
        buttonText="Voir mon offre personnalisée"
        onBack={onBack}
      />

      <Drawer
        placement="right"
        className="mobilityMutual__drawer right--drawer"
        closable
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={isMobile ? "98%" : "50%"}
      >
        <div className="drawer__wrapper">
          <div className="drawer__wrapper--header">
            <div className="title">
              <h3>Les niveaux de remboursement</h3>
            </div>
            <p>
              Chaque niveau correspond à des choix spécifiques concernant les
              professionnels de santé consultés et le niveau de remboursement
              souhaité. Voici une présentation des différents niveaux de besoins
              en santé :
            </p>
          </div>
          <Levels />
          <Button
            type={"default"}
            onClick={() => {
              setDrawerVisible(false);
            }}
          >
            Fermer
          </Button>
        </div>
      </Drawer>
    </Layout>
  );
}

export default View;
